<template>
  <SidebarModal :modal="modal">
    <div
      ref="modal"
      class="relative h-full w-full bg-gray-100 dark:bg-neutral-800"
    >
      <div
        class="border-1 shadow-around absolute bottom-2 right-2 flex gap-1 rounded-xl border-gray-100 bg-white/80 px-1.5 py-1.5 shadow-neutral-400/20 backdrop-blur-md dark:border-neutral-800 dark:bg-neutral-900/90 dark:shadow-none"
      >
        <button
          class="size-8 md:size-9 hover:text-primary flex cursor-pointer items-center justify-center rounded-lg bg-gray-100 text-neutral-600 ring-1 ring-gray-200 transition-colors dark:bg-neutral-700 dark:text-neutral-300 dark:ring-neutral-800"
          @click="refresh"
        >
          <LucideIcon icon="RefreshCcw" :size="16" />
        </button>

        <button
          v-allow-fullscreen
          class="size-8 md:size-9 hover:text-primary flex cursor-pointer items-center justify-center rounded-lg bg-gray-100 text-neutral-600 ring-1 ring-gray-200 transition-colors dark:bg-neutral-700 dark:text-neutral-300 dark:ring-neutral-800"
          @click="toggleFullscreen"
        >
          <LucideIcon
            :icon="isFullscreen ? 'Minimize' : 'Maximize'"
            :size="16"
          />
        </button>
      </div>
      <iframe
        :key="iframeKey"
        :src="modal?.payload?.src"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
        class="h-full w-full"
      >
        Error</iframe
      >
    </div>
  </SidebarModal>
</template>

<script>
import SidebarModal from '@/components/sidebar/SidebarModal.vue';
import AllowFullscreen from '@/libs/directives/AllowFullscreen';
export default {
  name: 'IframeModal',
  components: {
    SidebarModal,
  },
  directives: {
    AllowFullscreen,
  },
  props: {
    modal: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isFullscreen: false,
      iframeKey: 1,
    };
  },
  mounted() {
    document.addEventListener('fullscreenchange', this.handleFullscreenChange);
  },
  beforeDestroy() {
    if (this.panzoom) {
      document.removeEventListener(
        'fullscreenchange',
        this.handleFullscreenChange
      );
    }
  },

  methods: {
    handleFullscreenChange() {
      this.isFullscreen = !!document.fullscreenElement;
    },

    refresh() {
      this.iframeKey++;
    },

    toggleFullscreen() {
      if (!document.fullscreenElement) {
        this.$refs.modal.requestFullscreen();
      } else {
        document.exitFullscreen();
      }
    },
  },
};
</script>
